module.exports = {
      id: "envelope-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-72169aba3aaebb7b19ede7951c92022d.svg#envelope",
      toString: function () {
        return this.url;
      }
    }